export default __webpack_public_path__ + "static/media/coin upwards.6945d5f5.svg";